import React from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import logo from '../../public/static/images/logo.png';
import Button from '../Button';
import { ITUNES_APP_URL } from '../../constants';

const Navbar = ({ isHomepage = false }) => {
  const router = useRouter();

  const handleClick = () => {
    window.location.href = ITUNES_APP_URL;
  };

  return (
    <div className={styles.navbar} role="banner">
      <div
        className={styles.logoWrapper}
        onClick={!isHomepage ? () => router.push('/') : undefined}
      >
        <img className={styles.logo} src={logo} alt="Island logo" />
      </div>
      <Button
        className={styles.button}
        onClick={handleClick}
        text="Get island"
        height={38}
        backgroundColor="#0F0"
        shadowColor="#00D900"
        color="black"
      />
    </div>
  );
};

export default Navbar;
